<template>
  <div class="agency-map">
    <GmapMap
      ref="map"
      :min-zoom="minZoom"
      :max-zoom="maxZoom"
      :center="center"
      :zoom="zoom"
      :style="gmapStyles"
      @bounds_changed="fitZoom"
      @zoom_changed="update('zoom', $event)"
      @idle="loading = false"
    >
      <GmapMarker
        :key="marker.id"
        :position="position"
        :clickable="true"
        :draggable="true"
        @click="markerOpen = !markerOpen"
      >
        <GmapInfoWindow :opened="markerOpen">
          <Agency
            :name="marker.name"
            :phone="marker.phone_1"
            :mail="email"
            :address="marker.address"
            :chips="marker.chips"
            :fax="marker.fax"
            :note="marker.note"
            :bottom-chips="true"
          />
        </GmapInfoWindow>
      </GmapMarker>
    </GmapMap>
  </div>
</template>

<script>
import Agency from "@/components/patterns/CardAgency";

export default {
  name: "AgencyMap",
  components: { Agency },
  props: {
    marker: {
      type: Object,
      default: () => {},
    },
    defaultCenter: {
      type: Object,
      default: () => {},
    },
    defaultZoom: {
      type: Number,
      default: 0,
    },
    email: {
      type: String,
      default: "",
    },
    maxZoom: {
      type: Number,
      default: 20,
    },
    minZoom: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      mapBounds: {},
      zoom: this.defaultZoom,
      center: this.defaultCenter,
      loading: true,
      map: {},
      mapLoaded: false,
      markerOpen: false,
    };
  },
  computed: {
    gmapStyles() {
      if (!this.loading) {
        return {
          width: "100%",
          height: "100%",
        };
      }
      return null;
    },
    position() {
      return { lat: Number(this.marker.lat), lng: Number(this.marker.lon) };
    },
  },
  methods: {
    fitZoom() {
      this.zoom = Math.min(this.minZoom, this.$refs.map.zoom, this.zoom);
    },
    update(field, event) {
      if (field === "bounds") {
        this.mapBounds = event;
      } else {
        this.$set(this, field, event);
      }
    },
  },
};
</script>

<style lang="scss">
.agency-map {
  height: 100%;
  width: 100%;
}

.vue-map {
  height: 100%;
  width: 100%;

  .dea-agency {
    border: 0;
  }
}
</style>
